import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Set } from "immutable";
import * as React from "react";
import { GoogleTranslateMenuItem } from "../../../Shared/components/GoogleTranslate/GoogleTranslateMenuItem";
import { WiseConfig } from "../../../Shared/features/WiseConfig";
import { errorText, getNavigation } from "../../custom_api/api";
import { Button } from "./library/button";
import { Link as CustomLink, Link } from "./library/link";
import { trackLogin } from "./library/tracking";
const navigationStateZero = {
    items: "loading",
    secondaryItems: 'loading',
    menuOpen: false
};
const getMenuItemClassName = (title)=>title == "Activiteiten" ? "activiteiten" : title == "Collectie" ? "collectie" : title == "Lidmaatschap" ? "lidmaatschap" : title == "Vestigingen" ? "vestigingen" : "";
const loginRoute = ()=>`${WiseConfig().BaseUrl}/wise-apps/opac/branch/${WiseConfig().LibraryId}/my-account/checkouts/`;
const activePath = (path)=>path == window.location.pathname;
class Menu extends React.Component {
    render() {
        // TODO: Currently, the Desktop & Mobile version of the header are loaded at the same time.
        // We should either refactor this so the menu cannot be focused while on either other version
        return /*#__PURE__*/ _jsxs("nav", {
            className: "nav",
            "aria-label": "Primair",
            children: [
                /*#__PURE__*/ _jsx(DesktopMenu, {
                    ...this.props
                }),
                /*#__PURE__*/ _jsxs(Button, {
                    className: "nav__toggler",
                    handle: this.props.toggleMenu,
                    buttonProps: {
                        'aria-controls': 'a11y-nav-collapse',
                        'aria-expanded': this.props.menuOpen
                    },
                    children: [
                        "Menu ",
                        /*#__PURE__*/ _jsx("span", {
                            className: "sr-text",
                            children: this.props.menuOpen ? 'sluiten' : 'openen'
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "nav__hamburger",
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    "aria-hidden": "true"
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    "aria-hidden": "true"
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    "aria-hidden": "true"
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    "aria-hidden": "true"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(MobileMenu, {
                    ...this.props,
                    handle: this.props.toggleMenu
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = {};
    }
}
const SecondaryMobileMenu = (props)=>{
    if (props.items == 'loading' || props.items == 'error') return null;
    const { dropdown } = props;
    return /*#__PURE__*/ _jsxs("ul", {
        className: "utilities__menu utilities__menu--mobile",
        children: [
            props.items.toArray().map((m, i)=>m.external ? /*#__PURE__*/ _jsx("li", {
                    className: "utilities__menu-item",
                    children: /*#__PURE__*/ _jsx("a", {
                        className: "utilities__menu-link link link--secondary",
                        href: m.absolute,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: m.title
                    })
                }, i) : /*#__PURE__*/ _jsx("li", {
                    className: "utilities__menu-item",
                    children: /*#__PURE__*/ _jsx(Link, {
                        handle: ()=>props.handle(),
                        className: `utilities__menu-link link link--secondary ${activePath(m.relative) ? 'utilities__menu-link--active' : ''}`,
                        url: m.relative,
                        children: m.title
                    })
                }, i)),
            /*#__PURE__*/ _jsx(GoogleTranslateMenuItem, {
                dropdown,
                mobile: true
            })
        ]
    });
};
const SecondaryDesktopMenu = (props)=>{
    if (props.items == 'loading' || props.items == 'error') return null;
    return /*#__PURE__*/ _jsx("div", {
        className: "header__utility utilities--desktop",
        children: /*#__PURE__*/ _jsx("nav", {
            className: "utilities__nav",
            "aria-label": "Secondary navigation",
            children: /*#__PURE__*/ _jsxs("ul", {
                className: "utilities__menu",
                children: [
                    props.items.toArray().map((m, i)=>m.external ? /*#__PURE__*/ _jsx("li", {
                            className: "utilities__menu-item",
                            children: /*#__PURE__*/ _jsx("a", {
                                className: "utilities__menu-link link link--secondary link--arrow",
                                href: m.absolute,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: m.title
                            })
                        }, i) : /*#__PURE__*/ _jsx("li", {
                            className: "utilities__menu-item",
                            children: /*#__PURE__*/ _jsx(Link, {
                                className: `utilities__menu-link link link--secondary link--arrow ${activePath(m.relative) ? 'utilities__menu-link--active' : ''}`,
                                url: m.relative,
                                children: m.title
                            })
                        }, i)),
                    /*#__PURE__*/ _jsx(GoogleTranslateMenuItem, {
                        ...props
                    }),
                    /*#__PURE__*/ _jsx("li", {
                        className: "utilities__menu-item",
                        children: /*#__PURE__*/ _jsx(CustomLink, {
                            url: loginRoute(),
                            className: "utilities__menu-button button button--primary nav__button",
                            external: true,
                            handle: ()=>trackLogin(),
                            children: "Log in"
                        })
                    })
                ]
            })
        })
    });
};
const MobileMenu = (props)=>{
    const { dropdown } = props;
    return /*#__PURE__*/ _jsx("div", {
        className: "menu-wrap",
        id: "a11y-nav-collapse",
        "aria-hidden": !props.menuOpen,
        hidden: !props.menuOpen,
        children: /*#__PURE__*/ _jsxs("div", {
            className: "menu-wrap__inner",
            children: [
                /*#__PURE__*/ _jsxs("ul", {
                    className: "menu menu--mobile",
                    children: [
                        props.items.map((x)=>/*#__PURE__*/ _jsx("li", {
                                className: "menu__item",
                                children: x.external ? /*#__PURE__*/ _jsx("a", {
                                    className: `menu__link link link--secondary ${activePath(x.relative) ? 'menu__link--active' : ''}`,
                                    href: x.absolute,
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    onClick: props.handle,
                                    children: x.title
                                }, x.key) : /*#__PURE__*/ _jsx(Link, {
                                    url: x.relative,
                                    handle: props.handle,
                                    className: `menu__link link link--secondary ${activePath(x.relative) ? 'menu__link--active' : ''}`,
                                    children: x.title
                                }, x.key)
                            }, `li-${x.key}`)),
                        /*#__PURE__*/ _jsx("li", {
                            className: "menu__item",
                            children: /*#__PURE__*/ _jsxs("button", {
                                className: "menu__link link link--secondary link--iconed",
                                onClick: ()=>props.toggleSearchModal(),
                                children: [
                                    "Zoeken",
                                    /*#__PURE__*/ _jsx("svg", {
                                        className: "link__icon",
                                        width: "16px",
                                        height: "16px",
                                        "aria-hidden": "true",
                                        children: /*#__PURE__*/ _jsx("use", {
                                            xlinkHref: "#icon--search-dnb"
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(SecondaryMobileMenu, {
                    handle: props.handle,
                    items: props.secondaryItems,
                    dropdown
                }),
                /*#__PURE__*/ _jsx(CustomLink, {
                    url: loginRoute(),
                    className: "button button--primary nav__button",
                    external: true,
                    handle: ()=>trackLogin(),
                    children: "Log in"
                })
            ]
        })
    });
};
const DesktopMenu = (props)=>{
    return /*#__PURE__*/ _jsxs("ul", {
        className: "menu menu--desktop",
        children: [
            props.items.map((x)=>/*#__PURE__*/ _jsx("li", {
                    className: "menu__item",
                    children: x.external ? /*#__PURE__*/ _jsx("a", {
                        className: `menu__link link link--secondary ${activePath(x.relative) ? 'menu__link--active' : ''}`,
                        href: x.absolute,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: x.title
                    }, x.key) : /*#__PURE__*/ _jsx(Link, {
                        url: x.relative,
                        className: `menu__link link link--secondary ${activePath(x.relative) ? 'menu__link--active' : ''}`,
                        children: x.title
                    }, x.key)
                }, `li-${x.key}`)),
            /*#__PURE__*/ _jsx("li", {
                className: "menu__item",
                children: /*#__PURE__*/ _jsxs("button", {
                    className: "menu__link link link--secondary link--iconed",
                    onClick: ()=>props.toggleSearchModal(),
                    children: [
                        "Zoeken",
                        /*#__PURE__*/ _jsx("svg", {
                            className: "link__icon",
                            width: "16px",
                            height: "16px",
                            "aria-hidden": "true",
                            children: /*#__PURE__*/ _jsx("use", {
                                xlinkHref: "#icon--search-dnb"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
const Logo = (props)=>{
    return /*#__PURE__*/ _jsxs(Link, {
        url: "/",
        className: "logo",
        title: "Ga naar de homepagina",
        handle: props.closeMenu,
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: "sr-text",
                children: "Ga naar de homepagina"
            }),
            /*#__PURE__*/ _jsx("img", {
                width: "200",
                height: "20",
                src: "/bkw/images/dnb/logo.svg",
                alt: "De Nieuwe Bibliotheek",
                "aria-hidden": "true"
            })
        ]
    });
};
export class Header extends React.Component {
    closeMenu() {
        this.setState((s)=>({
                ...s,
                menuOpen: false
            }), ()=>document.body.classList.remove("menu--toggled"));
    }
    toggleMenu() {
        this.setState((s)=>({
                ...s,
                menuOpen: !s.menuOpen
            }), ()=>this.state.menuOpen ? document.body.classList.add("menu--toggled") : document.body.classList.remove("menu--toggled"));
    }
    componentDidMount() {
        const p = this.props;
        getNavigation("main").then((res)=>{
            if (res != "error" && res != "loading") {
                const items = Set(res);
                this.setState((s)=>({
                        ...s,
                        items: items
                    }));
            }
        });
        getNavigation("main-secondary").then((res)=>{
            if (res != "error" && res != "loading") {
                const items = Set(res);
                this.setState((s)=>({
                        ...s,
                        secondaryItems: items
                    }));
            }
        });
    }
    render() {
        const s = this.state;
        const { secondaryItems, menuOpen } = this.state;
        const { dropdown } = this.props;
        const toggleMenu = this.toggleMenu;
        const toggleSearchModal = ()=>{
            this.closeMenu();
            this.props.toggleSearchModal();
        };
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx("a", {
                    href: "#a11y-main",
                    className: "sr-text",
                    children: "Ga direct naar de content"
                }),
                /*#__PURE__*/ _jsx("a", {
                    href: "#a11y-footer",
                    className: "sr-text",
                    children: "Ga direct naar de footer"
                }),
                /*#__PURE__*/ _jsx("header", {
                    className: "header",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "header__inner container--full gutter--m align--center",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "header__container",
                                children: [
                                    /*#__PURE__*/ _jsx(Logo, {
                                        closeMenu: ()=>this.closeMenu()
                                    }),
                                    s.items == "loading" ? null : s.items == "error" ? errorText : /*#__PURE__*/ _jsx(Menu, {
                                        items: s.items,
                                        dropdown,
                                        secondaryItems,
                                        menuOpen,
                                        toggleMenu,
                                        toggleSearchModal
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(SecondaryDesktopMenu, {
                                items: s.secondaryItems,
                                dropdown
                            })
                        ]
                    })
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = navigationStateZero;
        this.toggleMenu = this.toggleMenu.bind(this);
        this.closeMenu = this.closeMenu.bind(this);
    }
}
{}